import ApiRequestManagerInstance from '../ApiRequestManager';
import Rail from '../../classes/rail';
import TranslationManager from '../../assets/locale/translationsManager';
import { IRailsRequest } from '../../types/interfaces/rail';
import { store } from '../../store/store';

function addonContentRequest(id: string) {
  const promise = new Promise<Rail[]>(async (resolve) => {
    try {
      const { user, channels: storeChannels } = store.getState();
      const response: IRailsRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'apiUrl',
          section: `media${user.isAnonymous ? 'free' : ''}`,
          subsection: 'addon',
          type: 'content',
          params: id + '?lang=' + TranslationManager.currentLanguage,
        },
      })) as unknown as IRailsRequest;
      let rails: Rail[] = [];
      if (response?.data?.length) {
        rails = response.data?.map((item) => new Rail(item));
      }
      rails.forEach((rail) => {
        rail.data = rail.data.filter((item) => {
          return storeChannels.channelsData?.find((ch) => {
            return ch.id === item?.channel?.id;
          });
        });
      });
      rails = rails.filter((rail) => rail.data.length);
      resolve(rails);
    } catch (e) {
      resolve([]);
    }
  });

  return promise;
}

export default addonContentRequest;
